import {v1 as uuidv1} from 'uuid';
import * as store from '@/store';

export function getUUID() {
    return uuidv1();
}

export function getRepoId() {
    return (store.getCurPage() && store.getCurPage().repositoryGuid) || '';
}

export function getDoc() {
    // 当前docGuid不存在的时候当前文档数据应该为空
    const {
        docGuid,
    } = store.getCurPage();
    return docGuid
        ? store.getCurDocument()
        : null;
}

export function getDocType() {
    return (getDoc() && getDoc()?.type) || '';
}
